export const faqItems = [
  {
    question: "51大赛的视频资源如何下载？",
    answer: "您可以在51大赛网站上浏览所有视频资源，每个视频详情页均提供下载入口。我们提供多种清晰度选择，从高清到超清应有尽有，满足不同设备与网络环境的需求。部分合集资源还支持一键批量下载，节省您的宝贵时间。"
  },
  {
    question: "网站的51大赛资源多久更新一次？",
    answer: "我们保持每日更新的节奏，赛事期间更是实时跟进。每当有新的51大赛视频、图片合集或攻略内容发布，我们的编辑团队会在第一时间整理并上线。您可以通过关注首页的动态快讯或订阅话题标签，第一时间获取最新51大赛资源上线的通知。"
  },
  {
    question: "如何快速找到我想要的51大赛合集内容？",
    answer: "首页提供了多种浏览方式：您可以通过热门话题标签快速筛选感兴趣的主题，也可以浏览专题索引按分类查找，或使用热门榜单发现当前最受欢迎的51大赛内容。图文推荐和焦点专题也能帮助您发现精彩内容。"
  },
  {
    question: "51大赛攻略都包含哪些方面的内容？",
    answer: "我们的攻略覆盖赛事解读、选手分析、战术复盘、观赛指南等多个维度。由资深赛事编辑团队撰写，结合51大赛视频与资源合集，为您提供从入门到精通的完整学习路径。无论您是初次接触还是资深爱好者，都能找到适合自己的内容。"
  }
];

export const topicItems = [
  { name: "赛事直播", heat: "9.8w", color: "bg-primary-100 text-primary-800" },
  { name: "精彩回放", heat: "8.5w", color: "bg-accent-100 text-accent-800" },
  { name: "选手集锦", heat: "7.2w", color: "bg-secondary-100 text-secondary-900" },
  { name: "幕后花絮", heat: "6.8w", color: "bg-primary-100 text-primary-800" },
  { name: "赛事攻略", heat: "5.9w", color: "bg-accent-100 text-accent-800" },
  { name: "视频下载", heat: "5.4w", color: "bg-secondary-100 text-secondary-900" },
  { name: "资源合集", heat: "4.7w", color: "bg-primary-100 text-primary-800" },
  { name: "热门排行", heat: "4.3w", color: "bg-accent-100 text-accent-800" },
  { name: "新人推荐", heat: "3.8w", color: "bg-secondary-100 text-secondary-900" },
  { name: "经典赛事", heat: "3.5w", color: "bg-primary-100 text-primary-800" },
  { name: "独家内容", heat: "3.2w", color: "bg-accent-100 text-accent-800" }
];

export const updateItems = [
  { date: "2026-07-30", title: "2026赛季51大赛决赛阶段视频合集正式上线", tag: "最新发布" },
  { date: "2026-07-28", title: "半决赛精彩回放资源已更新，高清下载通道开放", tag: "资源更新" },
  { date: "2026-07-25", title: "51大赛攻略专题：淘汰赛阶段战术深度解析", tag: "攻略上新" },
  { date: "2026-07-22", title: "小组赛选手个人集锦系列视频全部上线", tag: "合集发布" },
  { date: "2026-07-20", title: "网站新增赛事直播回放加速下载功能", tag: "功能升级" },
  { date: "2026-07-18", title: "51大赛幕后花絮独家内容限时开放浏览", tag: "独家内容" },
  { date: "2026-07-15", title: "2026赛季完整赛程表与观赛指南已发布", tag: "最新发布" }
];

export const aboutContent = {
  title: "关于51大赛",
  description: "51大赛是国内领先的赛事攻略与资源平台，致力于为赛事爱好者提供全方位的内容服务。我们汇聚了海量51大赛视频资源、高清图片合集以及深度攻略文章，帮助您不错过任何精彩瞬间。平台由资深赛事编辑团队运营，每日更新最新赛事内容，涵盖赛事直播回放、选手集锦、战术复盘、幕后花絮等多个维度。无论您是追求赛事精彩回放，还是想深入学习比赛战术，51大赛都是您的一站式内容中心。"
};

export const commentItems = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20warm%20friendly%20expression%20simple%20light%20background%20clean%20editorial%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "赛事迷小陈",
    date: "2026-07-29",
    text: "这个网站的资源整理得太全了！我之前找了好几个地方都没凑齐的51大赛合集，在这里一次性就下载到了。视频画质也很棒，强烈推荐给所有赛事爱好者。"
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%20simple%20light%20background%20clean%20editorial%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "攻略达人",
    date: "2026-07-27",
    text: "51大赛攻略板块的内容质量真的高，每个战术分析都写得很透彻。看完攻略再回看比赛录像，理解完全不一样了。网站更新速度也很快，每次比赛结束不久就有回放资源了。"
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20Chinese%20man%20with%20confident%20look%20simple%20light%20background%20clean%20editorial%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "资深观众老张",
    date: "2026-07-25",
    text: "关注51大赛好几年了，这个平台最大的优点就是内容分类清晰，想找什么类型的视频都能快速定位。最近新增的批量下载功能也很实用，省了不少时间。"
  }
];

export const indexItems = [
  { title: "2026赛季完整视频合集", count: 48, icon: "ri-play-circle-line" },
  { title: "历届经典赛事回顾", count: 156, icon: "ri-history-line" },
  { title: "选手个人精彩集锦", count: 89, icon: "ri-user-star-line" },
  { title: "赛事战术深度解析", count: 34, icon: "ri-lightbulb-line" },
  { title: "幕后花絮独家内容", count: 72, icon: "ri-camera-line" },
  { title: "观赛指南与赛程", count: 15, icon: "ri-calendar-check-line" },
  { title: "高清图片壁纸合集", count: 203, icon: "ri-image-line" },
  { title: "赛事数据统计分析", count: 28, icon: "ri-bar-chart-line" },
  { title: "新手入门教程系列", count: 12, icon: "ri-book-open-line" }
];

export const contactContent = {
  title: "联系我们",
  description: "如果您有51大赛相关的视频资源、攻略投稿或合作意向，欢迎通过以下方式联系我们。我们期待与更多赛事爱好者一起，打造更丰富的51大赛内容生态。",
  email: "contact@51dasai.com",
  wechat: "51大赛官方",
  qq: "1234567890"
};

export const mediaItems = [
  {
    title: "2026赛季决赛全场回放",
    duration: "2:45:30",
    views: "128.5万",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20esports%20competition%20stage%20with%20dramatic%20lighting%20and%20large%20screen%20displays%20warm%20orange%20and%20gold%20tones%20professional%20production%20atmosphere%20crowd%20silhouettes%20in%20background&width=640&height=360&seq=media-01&orientation=landscape"
  },
  {
    title: "半决赛选手精彩操作集锦",
    duration: "1:32:18",
    views: "96.3万",
    image: "https://readdy.ai/api/search-image?query=Intense%20gaming%20competition%20highlight%20moment%20with%20dynamic%20visual%20effects%20warm%20golden%20and%20amber%20color%20scheme%20professional%20esports%20atmosphere%20dramatic%20stage%20lighting&width=640&height=360&seq=media-02&orientation=landscape"
  },
  {
    title: "小组赛TOP10神级操作",
    duration: "0:58:42",
    views: "85.7万",
    image: "https://readdy.ai/api/search-image?query=Top%20ten%20esports%20highlights%20montage%20with%20exciting%20gameplay%20moments%20warm%20energetic%20color%20palette%20professional%20competition%20stage%20dramatic%20camera%20angles&width=640&height=360&seq=media-03&orientation=landscape"
  },
  {
    title: "赛事幕后花絮独家揭秘",
    duration: "0:42:15",
    views: "67.2万",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20esports%20event%20production%20team%20preparation%20and%20equipment%20setup%20warm%20documentary%20style%20lighting%20authentic%20atmosphere&width=640&height=360&seq=media-04&orientation=landscape"
  },
  {
    title: "冠军战队战术复盘分析",
    duration: "1:15:08",
    views: "54.8万",
    image: "https://readdy.ai/api/search-image?query=Esports%20tactical%20analysis%20with%20game%20map%20overlay%20and%20strategy%20markers%20professional%20coaching%20style%20visualization%20warm%20amber%20and%20gold%20tones&width=640&height=360&seq=media-05&orientation=landscape"
  }
];

export const carouselItems = [
  {
    title: "2026赛季51大赛冠军之路",
    description: "从小组赛到总决赛，完整记录冠军战队的荣耀征程。包含全部比赛视频、战术复盘和独家采访内容。",
    image: "https://readdy.ai/api/search-image?query=Champion%20team%20celebrating%20victory%20on%20esports%20stage%20with%20golden%20confetti%20and%20trophy%20dramatic%20lighting%20warm%20triumphant%20atmosphere%20professional%20event%20photography&width=800&height=450&seq=carousel-01&orientation=landscape",
    tag: "赛季专题"
  },
  {
    title: "历届经典赛事回顾合集",
    description: "回顾51大赛历史上的经典对决，重温那些令人热血沸腾的传奇时刻与不朽名场面。",
    image: "https://readdy.ai/api/search-image?query=Nostalgic%20esports%20classic%20match%20moments%20in%20warm%20vintage%20golden%20tones%20legendary%20players%20on%20stage%20dramatic%20retrospective%20atmosphere&width=800&height=450&seq=carousel-02&orientation=landscape",
    tag: "经典回顾"
  },
  {
    title: "新人选手崛起：潜力之星盘点",
    description: "盘点本赛季表现出色的新人选手，深度分析他们的技术特点、成长轨迹和未来潜力。",
    image: "https://readdy.ai/api/search-image?query=Rising%20star%20esports%20player%20focused%20on%20competition%20with%20determined%20expression%20warm%20spotlight%20lighting%20professional%20gaming%20setup%20aspirational%20atmosphere&width=800&height=450&seq=carousel-03&orientation=landscape",
    tag: "新人特辑"
  },
  {
    title: "51大赛战术研究院系列",
    description: "由专业教练团队带来的赛事战术深度解析，从BP策略到团战细节，全面提升你的比赛理解。",
    image: "https://readdy.ai/api/search-image?query=Esports%20coaching%20session%20with%20tactical%20board%20and%20game%20analysis%20display%20professional%20team%20strategy%20discussion%20warm%20amber%20lighting%20modern%20training%20facility&width=800&height=450&seq=carousel-04&orientation=landscape",
    tag: "深度攻略"
  }
];

export const featureItems = [
  {
    icon: "ri-download-cloud-2-line",
    title: "高速下载",
    description: "支持多线路高速下载，多种清晰度可选，按需获取51大赛视频资源"
  },
  {
    icon: "ri-stack-line",
    title: "内容齐全",
    description: "涵盖51大赛全部赛季视频、图片合集、攻略文章，一站式满足需求"
  },
  {
    icon: "ri-timer-flash-line",
    title: "实时更新",
    description: "每日更新最新51大赛内容，赛事期间实时跟进，不错过任何精彩"
  },
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "所有51大赛资源经过安全检测，下载链接稳定可靠，保障用户体验"
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    description: "支持电脑、平板、手机多端浏览，随时随地访问51大赛内容"
  }
];

export const appContent = {
  title: "随时随地，畅享51大赛",
  description: "即将推出移动端专属页面，在手机上也能流畅浏览51大赛视频资源、查看攻略合集。敬请期待！",
  platforms: ["iOS", "Android", "iPad"]
};

export const cardItems = [
  {
    title: "新手必看：51大赛入门完全指南",
    description: "从零开始了解51大赛，掌握赛事规则、观看技巧和资源获取方法。",
    image: "https://readdy.ai/api/search-image?query=Beginner%20guide%20to%20esports%20competition%20with%20friendly%20illustrated%20style%20warm%20inviting%20colors%20step%20by%20step%20learning%20concept%20clean%20design&width=600&height=400&seq=card-01&orientation=landscape",
    date: "2026-07-28",
    category: "新手攻略"
  },
  {
    title: "2026赛季最佳操作TOP20",
    description: "精选本赛季最令人惊叹的20个高光操作，每个都值得反复观看学习。",
    image: "https://readdy.ai/api/search-image?query=Epic%20esports%20highlight%20reel%20top%2020%20plays%20with%20dramatic%20visual%20style%20warm%20golden%20and%20amber%20accents%20professional%20gaming%20atmosphere&width=600&height=400&seq=card-02&orientation=landscape",
    date: "2026-07-25",
    category: "精彩集锦"
  },
  {
    title: "深度解析：决赛第四局战术博弈",
    description: "专业教练逐帧分析决赛关键局的战术决策，揭示胜负背后的深层逻辑。",
    image: "https://readdy.ai/api/search-image?query=Tactical%20esports%20game%20analysis%20with%20detailed%20strategy%20overlay%20professional%20coaching%20perspective%20warm%20amber%20lighting%20modern%20analytical%20setting&width=600&height=400&seq=card-03&orientation=landscape",
    date: "2026-07-22",
    category: "战术分析"
  },
  {
    title: "51大赛高清壁纸精选合集",
    description: "精选200+张51大赛主题高清壁纸，包含战队LOGO、选手写真和赛事瞬间。",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20esports%20themed%20wallpaper%20designs%20artistic%20style%20warm%20color%20palette%20professional%20clean%20aesthetic%20gaming%20inspired%20graphic%20design&width=600&height=400&seq=card-04&orientation=landscape",
    date: "2026-07-20",
    category: "资源合集"
  },
  {
    title: "选手专访：冠军队长的成长故事",
    description: "独家专访冠军队队长，分享训练日常、比赛心得和对51大赛的深厚感情。",
    image: "https://readdy.ai/api/search-image?query=Esports%20player%20portrait%20interview%20setting%20with%20warm%20studio%20lighting%20professional%20atmosphere%20inspirational%20mood%20clean%20editorial%20style&width=600&height=400&seq=card-05&orientation=landscape",
    date: "2026-07-18",
    category: "独家专访"
  },
  {
    title: "赛程日历：下半年重要赛事一览",
    description: "2026下半年51大赛及相关赛事完整赛程，提前标记，不错过任何重要比赛。",
    image: "https://readdy.ai/api/search-image?query=Esports%20tournament%20calendar%20schedule%20design%20with%20clean%20organized%20layout%20warm%20professional%20color%20scheme%20modern%20event%20planning%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape",
    date: "2026-07-15",
    category: "赛事资讯"
  }
];

export const rankingItems = [
  { rank: 1, title: "2026赛季决赛全场回放", views: "128.5万", trend: "up", change: "+3.2万" },
  { rank: 2, title: "半决赛精彩操作集锦合集", views: "96.3万", trend: "up", change: "+2.8万" },
  { rank: 3, title: "新手入门：51大赛完全指南", views: "82.1万", trend: "up", change: "+5.1万" },
  { rank: 4, title: "小组赛TOP10神级操作", views: "74.6万", trend: "down", change: "-1.2万" },
  { rank: 5, title: "冠军战队战术深度复盘", views: "68.9万", trend: "up", change: "+1.8万" },
  { rank: 6, title: "51大赛经典赛事回顾合集", views: "61.4万", trend: "up", change: "+0.9万" }
];